export default function TransationFailedIco() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      width="45"
      height="45"
    >
      <g
        transform="translate(1.4066 1.4066) scale(2.81 2.81)"
        style={{
          stroke: "none",
          strokeWidth: 0,
          fill: "none",
          fillRule: "nonzero",
          opacity: 1,
        }}
      >
        <path
          d="M28.5 65.5c-1.024 0-2.047-.391-2.829-1.172-1.562-1.562-1.562-4.095 0-5.656l33-33c1.561-1.562 4.096-1.562 5.656 0 1.563 1.563 1.563 4.095 0 5.657l-33 33C30.547 65.109 29.524 65.5 28.5 65.5z"
          fill="rgb(236,0,0)"
          strokeLinecap="round"
        />
        <path
          d="M61.5 65.5c-1.023 0-2.048-.391-2.828-1.172l-33-33c-1.562-1.563-1.562-4.095 0-5.657 1.563-1.562 4.095-1.562 5.657 0l33 33c1.563 1.562 1.563 4.095 0 5.656C63.548 65.109 62.523 65.5 61.5 65.5z"
          fill="rgb(236,0,0)"
          strokeLinecap="round"
        />
        <path
          d="M45 90C20.187 90 0 69.813 0 45 0 20.187 20.187 0 45 0c24.813 0 45 20.187 45 45C90 69.813 69.813 90 45 90zm0-82c-20.402 0-37 16.598-37 37 0 20.402 16.598 37 37 37 20.402 0 37-16.598 37-37 0-20.402-16.598-37-37-37z"
          fill="rgb(236,0,0)"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}
